import './ImpersonationBanner.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth/AuthContext';
import { useAccount } from '../../contexts/account/AccountContexts';
import { TokenData } from '../../models/auth/TokenData';
import { ADMIN, ACCOUNTS } from '../../routes/path';

export const IMPERSONATION_ORIGINAL_TOKEN_KEY = 'impersonation_original_token';

const ImpersonationBanner: React.FC = () => {
  const { t } = useTranslation();
  const { login } = useAuth();
  const { accountResponse, refetchData } = useAccount();
  const navigate = useNavigate();

  const originalTokenRaw = sessionStorage.getItem(IMPERSONATION_ORIGINAL_TOKEN_KEY);

  if (!originalTokenRaw) {
    return null;
  }

  const handleReturnToAdmin = () => {
    try {
      const originalTokenData = JSON.parse(originalTokenRaw) as TokenData;
      login(originalTokenData);
      sessionStorage.removeItem(IMPERSONATION_ORIGINAL_TOKEN_KEY);
      refetchData();
      navigate(`${ADMIN}${ACCOUNTS}`);
    } catch {
      sessionStorage.removeItem(IMPERSONATION_ORIGINAL_TOKEN_KEY);
    }
  };

  return (
    <div className="impersonation-banner">
      <span className="impersonation-banner__text">
        {t('impersonatingAs', { email: accountResponse?.email ?? '...' })}
      </span>
      <Button
        className="impersonation-banner__btn"
        label={t('returnToAdmin')}
        type="button"
        onClick={handleReturnToAdmin}
      />
    </div>
  );
};

export default ImpersonationBanner;